import FactoryReqJson from "./factory/FactoryReqJson";
import FactoryApiCliente from "./factory/FactoryApiCliente";
import {fetchAuthSession} from 'aws-amplify/auth';


const nombreHeaderTokenApi = 'x-rescliente-token';

const factoryHeader = async () => {
  const cognitoTokens = (await fetchAuthSession()).tokens;
  
  const token = cognitoTokens?.accessToken.toString();
  const dic = {};
  dic[nombreHeaderTokenApi] = token;//response.credentials.sessionToken
  return dic;
}

const factoryNoHeader = async () => {
  return Promise.resolve([]);
};


const RawReqJson = FactoryReqJson(factoryNoHeader);
const ApiReqJson = FactoryReqJson(factoryHeader);


let apiCliente = null;




/**
 *
 * @type {{getApijob: (function(): *), getApiEdoCta: (function(): *), getApiCartaLiquidacion: (function(): *), getApiFront: (function(): *), RawReqJson: {requestGET: function(*, null=): Promise<AxiosResponse<any>|*|{msg: *, success: boolean}|{msg: *, success: boolean}|undefined>, requestPOST: function(*, *, *): Promise<AxiosResponse<any>|*|{msg: *, success: boolean}|{msg: *, success: boolean}|undefined>, uploadFilePOST: function(*, *, *, *): Promise<AxiosResponse<any>|*|{msg: *, success: boolean}|{msg: *, success: boolean}|undefined>, requestPUTFile: function(*, *): Promise<AxiosResponse<any>|*|{msg: *, success: boolean}|{msg: *, success: boolean}|undefined>, requestDELETE: function(*, *): Promise<AxiosResponse<any>|*|{msg: *, success: boolean}|{msg: *, success: boolean}|undefined>}, getApiCredito: (function(): *), getApiGestion: (function(): *), geApitEBR: (function(): *), getApiIntFimubac: (function(): *)}}
 */

const Api = {
  RawReqJson,
  getApiCliente: () => {
    if (!apiCliente) {
      apiCliente = FactoryApiCliente(ApiReqJson)
    }
    return apiCliente;
  },
}

export default Api